module.exports = __webpack_public_path__ + "img/storeStory_entrance_icon250002.c634dc19.jpeg";